<template>
    <ConfirmationModal
        :visible.sync="showModal"
        :is-loading="isLoading"
        :is-submiting="isSubmiting"
        :disabled="!selectedId"
        title="Enviar notificação"
        description="Deseja realmente enviar uma notificação?"
        confirm-text="Confirmar"
        cancel-text="Cancelar"
        icon="el-icon-check"
        confirm-type="success"
        tag-type="success"
        @cancel="toggleModal"
        @confirm="onSubmit"
        @closed="resetModal"
    />
</template>
<script>
    // Components
    import { Notification } from "element-ui";

    import ConfirmationModal from "@/components/_micro/modals/ConfirmationModal.vue";

    // Api
    import { NotificacaoApi } from "@/api/NotificacaoApi";

    const notificacaoApi = new NotificacaoApi();

    export default {
        data() {
            return {
                selectedId: null,
                notificacao: null,
                showModal: false,
                isLoading: false,
                isSubmiting: false,
            }
        },
        methods: {
            async show() {
                try {
                    this.isLoading = true;

                    const res = await notificacaoApi.submitNotification(this.selectedId);

                    this.notificacao = res?.data ?? res;
                } catch (err) {
                    Notification.error({
                        title: 'Erro',
                        message: 'Não foi possível obter a notificação! Algo inesperado ocorreu.'
                    });
                } finally {
                    this.isLoading = false;
                }
            },
            async onSubmit() {
                if (!this.selectedId) return;

                this.isSubmiting = true;

                try {
                    await notificacaoApi.destroy(this.selectedId);

                    Notification.success({
                        title: 'Sucesso',
                        message: 'Notificação excluída com sucesso!'
                    });

                    this.$emit('deleted');
                } catch (error) {
                    Notification.error({
                        title: 'Erro',
                        message: 'Não foi possível excluir a notificação!'
                    });
                } finally {
                    this.isSubmiting = false;
                    this.toggleModal();
                }
            },
            /**Modal */
            toggleModal() {
                this.showModal = !this.showModal;
            },
            resetModal() {
                this.selectedId = null;
                this.notificacao = null;
            },
        },
        components: {
            ConfirmationModal,
        },
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/_macro/notificacao/NotificacaoConfirmSubmitModal.vue